// @ts-nocheck

import { createSelector } from 'reselect';

import { makeEntitiesBetslipEntityBetslipReferenceByBetslipIdSelector } from '../../../../selectors/betslip.selector';
import { selectEntitiesBetslipsEntity } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';

const makeBetslipOptionsModalPropsSelector = () => {
  const betslipReferenceSelector = makeEntitiesBetslipEntityBetslipReferenceByBetslipIdSelector();

  const selectBetslipReference = createSelector([betslipReferenceSelector], (betslipReference) => betslipReference);

  const selectOutcomes = createSelector([selectEntitiesOutcomes, selectEntitiesBetslipsEntity], (outcomes, betslip) => {
    const outcomeIds = betslip?.details?.map((d) => d?.outcomeId);

    return outcomeIds?.map((outcomeId) => outcomes[outcomeId]);
  });

  const selectShowBasketItem = createSelector([selectOutcomes], (outcomes) => {
    if (outcomes?.some((outcome) => outcome?.subOutcomes)) {
      return true;
    }
    return outcomes?.some((outcome) => outcome?.available);
  });

  return createSelector([selectBetslipReference, selectShowBasketItem], (betslipReference, showBasketMenuItem) => ({
    betslipReference,
    showBasketMenuItem,
  }));
};

export default makeBetslipOptionsModalPropsSelector;
